import { _ as e } from "./objectWithoutProperties-a0edb288.js";
import t from "react";
import { _ as h } from "./extends-093996c9.js";

var l = function l(e) {
  var l = e.dark,
      r = void 0 === l ? "#000000" : l,
      c = e.light,
      a = void 0 === c ? "#fff" : c,
      o = e.red,
      s = void 0 === o ? "#A01316" : o,
      v = e.schema,
      i = void 0 === v ? "common" : v,
      m = {
    isotypebackground: s,
    isotypeletter: a,
    letters: s,
    altletters: r,
    mode: "normal"
  };
  return "light" === i && (m.isotypebackground = s, m.isotypeletter = a, m.letters = a, m.altletters = a), "white" === i && (m.isotypebackground = a, m.isotypeletter = r, m.letters = a, m.altletters = a, m.mode = "isocut"), t.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1329.67 184.47"
  }, e), t.createElement("g", null, "isocut" === m.mode ? t.createElement("g", null, t.createElement("mask", {
    id: "iso-mask-domingo"
  }, t.createElement("path", {
    fill: m.isotypebackground,
    d: "M0 0h192.84v184.47H0z"
  }), t.createElement("path", {
    fill: m.isotypeletter,
    d: "M23.51 33.54h18.48v101.02h52.85v16.39H23.51V33.54M115.98 49.94H81.1v-16.4h88.24v16.4h-34.88v101.01h-18.48V49.94"
  })), t.createElement("path", {
    fill: m.isotypebackground,
    mask: "isocut" === m.mode ? "url(#iso-mask-domingo)" : "",
    d: "M0 0h192.84v184.47H0z"
  })) : t.createElement("g", null, t.createElement("path", {
    fill: m.isotypebackground,
    d: "M0 0h192.84v184.47H0z"
  }), t.createElement("path", {
    fill: m.isotypeletter,
    d: "M23.51 33.54h18.48v101.02h52.85v16.39H23.51V33.54M115.98 49.94H81.1v-16.4h88.24v16.4h-34.88v101.01h-18.48V49.94"
  })), t.createElement("path", {
    fill: m.altletters,
    d: "M243.58 10.35h46.11c53.74 0 89.48 33.54 89.48 83.82S343.69 178 289.69 178h-46.11zM288 155.05c43.64 0 64.11-25.13 64.11-60.88s-20.52-60.9-64.11-60.9h-18.28v121.78zM391.48 94.17c0-50 38.47-86 86.54-86 47.82 0 86.27 36 86.27 86s-38.45 86-86.27 86c-48.02.03-86.54-35.96-86.54-86zm146.19 0c0-35.75-24.65-62.63-59.65-62.63S418.1 58.42 418.1 94.17s24.9 62.62 59.9 62.62 59.67-26.87 59.67-62.62zM584.5 8.62h2.71l80.1 93.68L746.7 8.62h2.73V178h-24.91V91c0-9.37 1-24.15 1-24.15s-8.12 12.56-15 20.2L668.3 137.8h-2.94L623.19 87c-6.39-7.64-14.77-20.2-14.77-20.2s1 14.78 1 24.15v87H584.5zM778.25 10.35h25.88V178h-25.88zM870.94 80.12c-6.66-7.16-15.79-18.73-15.79-18.73a235.79 235.79 0 011.74 24.16V178h-24.18V8.62h3.46L928.63 108c6.39 6.91 15.51 18.73 15.51 18.73s-1.72-14.78-1.72-24.15V10.35h24.16v169.36h-3.2zM986.78 94.17c0-50 36.25-85.79 86-85.79 25.63 0 45.85 7.15 59.42 22.44l-17.5 17.51c-9.62-10.12-22-16.53-41.92-16.53-35 0-59.41 26.62-59.41 62.37s24.65 62.62 62.62 62.62c17.25 0 32-4.44 41.41-10.85v-29.58h-45.1V93.43h69v65.33c-10.86 9.85-34 21.44-65.33 21.44-52.22 0-89.19-35.99-89.19-86.03zM1156.87 94.17c0-50 38.44-86 86.52-86 47.83 0 86.28 36 86.28 86s-38.45 86-86.28 86c-48.08.03-86.52-35.96-86.52-86zm146.18 0c0-35.75-24.65-62.63-59.66-62.63s-59.9 26.88-59.9 62.63 24.88 62.62 59.9 62.62 59.66-26.87 59.66-62.62z"
  })));
},
    r = function r(e) {
  var l = e.dark,
      r = void 0 === l ? "#000000" : l,
      c = e.light,
      a = void 0 === c ? "#ffffff" : c,
      o = e.red,
      s = void 0 === o ? "#A01316" : o,
      v = e.schema,
      i = {
    isotypebackground: s,
    isotypeletter: a,
    letters: s,
    altletters: r
  };
  return "light" === (void 0 === v ? "common" : v) && (i.isotypebackground = s, i.isotypeletter = a, i.letters = a, i.altletters = s), t.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2553.67 184.47"
  }, e), t.createElement("g", {
    "data-name": "Layer 2"
  }, t.createElement("g", {
    "data-name": "grupo copesa"
  }, t.createElement("g", {
    fill: i.letters
  }, t.createElement("path", {
    d: "M524.69 33.34h-49.85V9.87h126.24v23.47h-49.94v144.57h-26.45V33.34zM859.3 177.91h-31.4l-28.66-40.83a84.29 84.29 0 01-12.1.76h-16.59v40.07h-26.41V9.87h43c46.2 0 71.65 25.43 71.65 64.23 0 26-11.59 46-33.62 56.13zm-73.07-62.8c32.29 0 45.38-15.29 45.38-41 0-25.4-13.31-40.76-45.38-40.76h-15.68v81.77zM869.65 93.88c0-49.66 37.82-86.23 85.75-86.23 31.18 0 52.65 12.1 67.25 32.6l-20.27 14.34c-11.18-15.07-25.47-23-47.7-23-33.39 0-57.61 26.71-57.61 62.3 0 36.35 24.79 62.28 58.57 62.28 21.77 0 37.83-8.19 50.45-24.51l20.52 14.13c-17.3 23-39.31 34.34-71.93 34.34-48 0-85-36.6-85-86.24M1281.38 177.91H1250l-28.69-40.83a84.1 84.1 0 01-12.06.76h-16.47v40.07h-26.52V9.87h43c46.19 0 71.69 25.43 71.69 64.23 0 26-11.63 46-33.65 56.13zm-73.21-62.8c32.4 0 45.48-15.29 45.48-41 0-25.4-13.4-40.76-45.48-40.76h-15.44v81.77zM1313.41 177.91h-26.67l73.64-171.48h1.51l73.87 171.48h-27.88l-9.66-23.47h-75.12zm47.52-113.45l-28 66.47h55.41zM1150.36 154.44h-82.99v-28.46h71.35v-22.97h-71.35V33.32h82.99V9.87h-109.43v168.04h109.43v-23.47zM644.06 126.01h71.42v-23h-71.42V33.34h83.9V9.87h-110.3v168.04h110.46v-23.47h-84.06v-28.43zM243.47 9.96h26.41v144.53h75.89v23.49h-102.3V9.96z"
  }), t.createElement("path", {
    d: "M353.54 178h-26.72L400.48 6.49H402L475.85 178h-27.92l-9.59-23.49h-75.2zM401 64.56L373.1 131h55.3z"
  })), t.createElement("path", {
    fill: i.altletters,
    d: "M1467.58 10.35h46.11c53.74 0 89.48 33.54 89.48 83.82S1567.69 178 1513.69 178h-46.11zm44.42 144.7c43.64 0 64.11-25.13 64.11-60.88s-20.47-60.9-64.11-60.9h-18.23v121.78zM1615.48 94.17c0-50 38.47-86 86.54-86 47.82 0 86.27 36 86.27 86s-38.45 86-86.27 86c-48.02.03-86.54-35.96-86.54-86zm146.19 0c0-35.75-24.65-62.63-59.65-62.63s-59.92 26.88-59.92 62.63 24.9 62.62 59.9 62.62 59.67-26.87 59.67-62.62zM1808.5 8.62h2.71l80.1 93.68 79.39-93.68h2.73V178h-24.91V91c0-9.37 1-24.15 1-24.15s-8.12 12.56-15 20.2l-42.22 50.75h-2.94L1847.19 87c-6.39-7.64-14.77-20.2-14.77-20.2s1 14.78 1 24.15v87h-24.92zM2002.25 10.35h25.88V178h-25.88zM2094.94 80.12c-6.66-7.16-15.79-18.73-15.79-18.73a235.79 235.79 0 011.74 24.16V178h-24.18V8.62h3.46l92.46 99.38c6.39 6.91 15.51 18.73 15.51 18.73s-1.72-14.78-1.72-24.15V10.35h24.16v169.36h-3.2zM2210.78 94.17c0-50 36.25-85.79 86-85.79 25.63 0 45.85 7.15 59.42 22.44l-17.5 17.51c-9.62-10.12-21.95-16.53-41.92-16.53-35 0-59.41 26.62-59.41 62.37s24.65 62.62 62.62 62.62c17.25 0 32.05-4.44 41.41-10.85v-29.58h-45.1V93.43h69v65.33c-10.86 9.85-34 21.44-65.33 21.44-52.22 0-89.19-35.99-89.19-86.03zM2380.87 94.17c0-50 38.44-86 86.52-86 47.83 0 86.28 36 86.28 86s-38.45 86-86.28 86c-48.08.03-86.52-35.96-86.52-86zm146.18 0c0-35.75-24.65-62.63-59.66-62.63s-59.9 26.88-59.9 62.63 24.88 62.62 59.9 62.62 59.66-26.87 59.66-62.62z"
  }), t.createElement("path", {
    fill: i.isotypebackground,
    d: "M0 0h192.84v184.47H0z"
  }), t.createElement("path", {
    fill: i.isotypeletter,
    d: "M23.51 33.54h18.48v101.02h52.85v16.39H23.51V33.54M115.98 49.94H81.1v-16.4h88.24v16.4h-34.88v101.01h-18.48V49.94"
  }))));
},
    c = ["version"],
    a = function a(h) {
  var a = h.version,
      o = void 0 === a ? "large" : a,
      s = e(h, c);
  return console.log("version", o), "small" === o ? t.createElement(l, s) : t.createElement(r, s);
};

export { a as LaTerceraDomingo };